
// Innehållsförteckning på artikelsidan
$(function () {
    if ($('.a-article-content').length) {
        var h2 = $('#innehall h2');
        if (h2.length) {
            h2.each(function (i) {
                var self = $(this);
                self.attr('id', 'title' + i).attr('class', 'title');
                $('#innehallsfortecking').append('<a id="link' + i + '" href="#title' + i + '">' + self.html() + '</a>');
            });
        } else {
            $('.a-article-content').hide();
            return;
        }

        $(document).on('click', '.accordion-body a[href^="#"]', function (e) {
            // Target element id
            var id = $(this).attr('href');

            // Target element
            var $id = $(id);
            if (!$id.length) {
                return;
            }

            // Prevent standard hash navigation (avoid blinking in IE)
            e.preventDefault();

            // Top position relative to the document
            var pos = $id.offset().top;

            // Animated top scrolling
            $('body, html').animate({scrollTop: pos});
        });
    }
});

$(function () {
    if ($('.hopp-lankar').length) {
        $(document).on('click', '.hopp-lankar a[href^="#"]', function (e) {
            // Target element id
            var id = $(this).attr('href');

            // Target element
            var $id = $(id);
            if (!$id.length) {
                return;
            }

            // Prevent standard hash navigation (avoid blinking in IE)
            e.preventDefault();

            // Top position relative to the document
            var pos = $id.offset().top - 30;

            // Animated top scrolling
            $('body, html').animate({scrollTop: pos}, 1000);
        });
    }

    if ($('.belopp').length) {
        $(document).on('click', 'a[href^="#"]', function (e) {
            var id = $(this).attr('href');
            var $id = $(id);
            if (!$id.length) {
                return;
            }
            e.preventDefault();
            var pos = $id.offset().top - 30;
            $('body, html').animate({scrollTop: pos}, 1000);
        });
    }
});
